import Button from "react-bootstrap/Button";
import "../../styles.css";

const SubscribersActions = (props) => {
    const { busy, login, setLogin, handleSubmit, setHistory } = props;

    const clearSearchText = () => {
        setLogin('');
    }

    return (
        <>
            <div className="my-1 top-3">
                <input
                    type="text"
                    className={`form-control h-50 ${login ? 'mr-0' : ''}`}
                    id="login"
                    placeholder="Subscriber"
                    disabled={busy}
                    onChange={(e) => setLogin(e.target.value)}
                    value={`${login}`}
                />
                {
                    login && <i className="fal fa-times search-clear-icon" onClick={clearSearchText} />
                }
            </div>

            <div className="mx-2 my-1">
                <Button
                    variant="primary"
                    disabled={busy}
                    onClick={handleSubmit}
                >
                    {busy ? "Searching..." : "Search"}
                </Button>
            </div>

            <div className="my-1 ml-5">
                <select
                    id="history"
                    onChange={(e) => setHistory(e.target.value)}
                >
                    <option value="monthly">Monthly for last 12 months</option>
                    <option value="yearly">Yearly for last 12 years</option>
                </select>
            </div>
        </>
    );
};

export default SubscribersActions;
